import { render, staticRenderFns } from "./ChooseGoods.vue?vue&type=template&id=c2e981ca&scoped=true&"
import script from "./ChooseGoods.vue?vue&type=script&lang=js&"
export * from "./ChooseGoods.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGoods.vue?vue&type=style&index=0&id=c2e981ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e981ca",
  null
  
)

export default component.exports